var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-15.000000, -45.000000)","id":"Shape","fillRule":"nonzero","fill":"#555555"},React.createElement("polygon",{"points":"31 46.6171429 29.3828571 45 23 51.3828571 16.6171429 45 15 46.6171429 21.3828571 53 15 59.3828571 16.6171429 61 23 54.6171429 29.3828571 61 31 59.3828571 24.6171429 53"})))]);
}

Close.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = Close;

Close.default = Close;
